module.exports = __webpack_public_path__ + "static/media/41.8519c14e.jpg";